import { usePagination } from 'react-instantsearch'

import type { ReactElement } from 'react'
import type { UsePaginationProps } from 'react-instantsearch'

import Pagination from '~/components/Pagination'

const AlgoliaPagination = (props: UsePaginationProps): ReactElement => {
  /** Effects */

  const { currentRefinement, nbPages, refine } = usePagination(props)

  /** Handlers */

  const handleMoveCursor = (page: number) => () => refine(page)

  /** Render */

  return (
    <Pagination
      className="table-pagination"
      currentPage={currentRefinement}
      goBack={handleMoveCursor(currentRefinement - 1)}
      goNext={handleMoveCursor(currentRefinement + 1)}
      goToPage={(page: number) => refine(page)}
      pageTotal={nbPages}
    />
  )
}

export default AlgoliaPagination
